<template>
  <div
    class="wf-swatch-room-gallery"
  >
    <div class="wf-swatch-room-gallery-room">  
      <img class="wf-swatch-room-gallery-room-image"
           v-if="items.length > 0"
           :src="$helpers.getRoomSceneThumbnailImageUrlFromAlgoliaResult(items[selectedItemIndex])"
           alt=""
      >
    </div>
    <ul 
      class="wf-swatch-room-gallery-swatches"
    >
      <li
        class="wf-swatch-room-gallery-swatch-item"
        v-for="(item, itemIndex) in items"
        :key="item.sellingStyleNumber"
      >
        <input
          class="wf-swatch-room-gallery-radio"
          :id="`wf-swatch-room-gallery-radio-${collectionCode}-${item.sellingStyleNumber}`"
          :name="`wf-swatch-room-gallery-${collectionCode}[]`"
          :value="itemIndex"
          v-model="selectedItemIndex"
          type="radio"
        >
        <label
          class="wf-swatch-room-gallery-label"
          :for="`wf-swatch-room-gallery-radio-${collectionCode}-${item.sellingStyleNumber}`"
        >
          <div class="wf-swatch-room-gallery-swatch">
            <img class="wf-swatch-room-gallery-swatch-image"
                 :src="$helpers.getColorThumbnailImageUrl(item.sellingStyleNumber, item.colors[0].colorNumber)"
                 alt=""
            >
            <div class="wf-swatch-room-gallery-swatch-title description">
              {{ item.sellingStyleName }}
            </div>
          </div>
        </label>
      </li>
      <li class="align-self-center">
        <a class="btn" :href="$helpers.getCollectionOverviewUrl(collectionCode)">
          {{ $resourceString["common.seeMore"] }}
          <span class="png-icon png-icon-icons-glyph--k-arrow-right-sm" />
        </a>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  props: {
    collection: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      selectedItemIndex: 0,
    };
  },
  computed: {
    items() {
      return this.collection?.products.length > 4 ? this.collection.products.slice(0,4) : this.collection.products; 
    },
    collectionCode() {
      return this.collection?.collectionCode
    }
  }
};
</script>